/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
import React, { useState, useCallback, useRef, useEffect } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { Link } from '..'

import useStyles from './styles'


const LangSelector = (props) => {
  const [isOpen, setIsOpen] = useState(false)

  const classes = useStyles({ ...props, isOpen })
  const { className, locales } = props

  const $container = useRef()

  const handleToggleMenu = (event) => {
    event.preventDefault()
    setIsOpen(!isOpen)
  }

  const handleCloseMenu = useCallback(() => {
    setIsOpen(false)
  }, [])

  const renderCurrentLocale = useCallback(() => {
    const current = locales.find((locale) => locale.current)

    if (!current) {
      return
    }
    return <abbr title={current?.title}>{current?.abbreviation}</abbr>
  }, [locales])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if ($container.current && !$container.current.contains(event.target)) {
        handleCloseMenu()
      }
    }

    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [$container, handleCloseMenu])

  return (
    <div
      className={cx(className, classes.container)}
      ref={$container}
    >
      <button
        className={classes.trigger}
        type="button"
        onClick={handleToggleMenu}
      >
        {renderCurrentLocale()}
      </button>
      {locales && (
        <ul className={classes.list}>
          {locales.map((locale, index) => (
            <li
              className={classes.item}
              key={`locale-${index}`}
            >
              <Link
                className={classes.link}
                {...locale.linkProps}
              >
                <abbr title={locale.name}>{locale.abbreviation}</abbr>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

LangSelector.propTypes = {
  className: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.object),
}

LangSelector.defaultProps = {
  className: null,
  locales: null,
}

export default LangSelector
